<section class="pt-16 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Amministrazione Trasparente', route: '/backoffice/amministrazione-trasparente/' }]"></app-breadcrumb-backoffice>
</section>

<section class="px-container pb-16">
    <div class="ac-section-head">
        <h2>Elenco file</h2>
    </div>

    <p-table #dt
        [loading]="loading"
        [value]="files"
        responsiveLayout="stack"
        [breakpoint]="'960px'"
        styleClass="scheda-tabella p-datatable-sm"
        [paginator]="true"
        [showCurrentPageReport]="true"
        [rowHover]="true"
        [globalFilterFields]="['titolo','categoria']"
        currentPageReportTemplate="{first} di {last} su {totalRecords} file"
        [rows]="5"
        [rowsPerPageOptions]="[5, 10, 20, 50]">
        <ng-template pTemplate="caption">
            <div class="flex lg:flex-row flex-col gap-3 w-full items-stretch">
                <input type="text" pInputText class="flex-1" (input)="onGlobalFilter(dt, $event)" placeholder="Cerca file…" />
                <div class="table-toolbar-btns">
                    <a class="acc-btn acc-btn-primary" routerLink="/backoffice/amministrazione-trasparente/add">
                        <i class="bi bi-plus"></i>
                        Aggiungi file
                    </a>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="categoria" class="w-1/4">Categoria <span class="inline-flex"><p-sortIcon field="categoria" /></span></th>
                <th pSortableColumn="titolo" class="w-2/4">Titolo <span class="inline-flex"><p-sortIcon field="titolo" /></span></th>
                <th class="w-1/4 text-center">Azioni</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-file>
            <tr>
                <td>
                    <span class="p-column-title">Categoria</span>
                    {{file.categoria.replace('_', ' ') | titlecase}}
                </td>
                <td>
                    <span class="p-column-title">Titolo</span>
                    <span class="cell-nome">{{file.titolo}}</span>
                </td>
                <td class="text-center">
                    <span class="p-column-title">Azioni</span>
                    <div class="table-actions">
                        <i class="bi bi-pencil" [routerLink]="'/backoffice/amministrazione-trasparente/' + file.id"></i>
                        <p-divider layout="vertical"></p-divider>
                        <p-confirmPopup #deleteFile>
                            <ng-template pTemplate="headless" let-message>
                                <div class="border-round p-3">
                                    <span class="text-base">{{ message.message }}</span>
                                    <div class="flex align-items-center gap-2 mt-3">
                                        <button type="button" class="acc-btn flex-1" (click)="onDeleteFile()">Elimina</button>
                                        <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onAnnullaDeleteFile()">Annulla</button>
                                    </div>
                                </div>
                            </ng-template>
                        </p-confirmPopup>
                        <i class="bi bi-trash" (click)="onOpenDeleteFile($event, file)"></i>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="3">Nessun file trovato.</td>
            </tr>
        </ng-template>
    </p-table>
</section>
